<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
    </el-row>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-row v-if="!inEditingMode"> 
      <el-col :xs="8" :sm="8" :lg="8">
        <el-button v-if="from == ''" type="normal" @click.prevent="goBack" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
        </el-button>
        <el-button v-if="from !=''" type="info" @click.prevent="goBackReport" class="ml-20" circle><i class="el-icon-d-arrow-left"></i>
        </el-button>
      </el-col>
      <el-col :xs="16" :sm="16" :lg="16" style="text-align: right">
        <el-button v-if="canEdit" type="warning" @click.prevent="handleDraft">暫存 <i
            class="el-icon-s-claim"></i></el-button>
        <el-button v-if="canEdit" type="primary" @click.prevent="handleSign" class="mr-20">送簽核 <i
            class="el-icon-s-claim"></i></el-button>
      </el-col>
    </el-row>

    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->

    <!--    基本資料-->
    <el-row v-if="!inEditingMode">    
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>基本資料</span>
              <el-button style="float: right; padding: 2px 0; margin-top: -12px" type="text"><el-tag type="success">{{basicForm.status | fmtSignResult }}</el-tag></el-button>
            </div>
            <div>
              <el-form :model="basicForm" :rules="rules" ref="basicDataForm" label-width="100px">
                <el-row>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>填單人: {{basicForm.userObj.username}} </p>
                </el-col>
                <el-col :xs="12" :sm="12" :md="12">
                  <p>報表日期: {{basicForm.startDate | fmtDate}}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <p class="mt-20">標題: {{basicForm.title}} </p>
                </el-col>
              </el-row>
              </el-form>
            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>

      <!-- 出勤資料 -->
      <!-- <el-row v-if="!inEditingMode"> 
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>出勤資料</span>
          </div>
          <div>
            <el-form class="myform" label-position="top"　:model="basicForm"
                     :rules="visitRules"
                     ref="visitDataForm">
              <el-row>
                <el-col :xs="24" :sm="24" :md="24">
                  <el-form-item label="出勤前工作" prop="preCheckTree">
                    <el-tree
                        :data="preCheckOption"
                        show-checkbox
                        node-key="value"
                        ref="tree"
                        :props="props"
                        :default-checked-keys="precheckListOption">
                    </el-tree>
                  </el-form-item>

                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>
  </el-row> -->
   


  <el-row v-if="basicForm.status === 'close' && task.tableData.length > 0"> 
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>工作項目資料</span>
            </div>
            <div>

              <el-table :data="task.tableData" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="項目" prop="taskTypeName">
                </el-table-column>
                <el-table-column label="" type="expand" >
                  <template slot-scope="scope">
                  <p class="mt-10 ml-10">內容 : {{scope.row.notes}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                    
                  </li>
                </ol>
                </template>
                </el-table-column>
                
                
              </el-table>

             
            </div>
          </el-card>
        </el-main>
      </el-col>
  </el-row>
  
   

    


    <!-- ###################################################################################################### -->
    <!-- 客戶拜訪資料 -->
    <!-- ###################################################################################################### -->
    
    <!--    客戶拜訪資料-->
    <el-row v-if="!inEditingMode"> 
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>現有客戶服務紀錄</span>
              <el-button v-if="canEdit" style="float: right; padding: 5px 12px; margin-top: -7px;" 　type="primary"
                         @click.prevent="handleAddCust" class="mr-20" id="add_cust_btn"><i class="el-icon-circle-plus-outline"></i> 新增</el-button>
            </div>
            <div>
              <el-table :data="tableData" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="客戶名稱" prop="customer.company">
                </el-table-column>
                <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10" v-if="scope.row.customer.name !== null && scope.row.customer.name !== ''">聯絡人: {{scope.row.customer.name}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.customer.address !== null && scope.row.customer.address !== ''">地址: {{scope.row.customer.address}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.customer.phone1 !== null && scope.row.customer.phone1 !== ''">電話: {{scope.row.customer.phone1}}</p>

                  <p class="mt-20 ml-10" v-if="scope.row.promoteCatalog !== '' || scope.row.promoteSample !== '' || scope.row.promoteOther !== ''">－宣傳品－</p>
                  <p class="mt-10 ml-10" v-if="scope.row.promoteCatalog !== null && scope.row.promoteCatalog !== ''">{{scope.row.promoteCatalog}}: {{scope.row.item1Name}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.promoteSample !== null && scope.row.promoteSample !== ''">{{scope.row.promoteSample}}: {{scope.row.item2Name}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.promoteOther !== null && scope.row.promoteOther !== ''">{{scope.row.promoteOther}}: {{scope.row.item3Name}}</p>

                  <p class="mt-20 ml-10" v-if="scope.row.notes !== null && scope.row.notes !== ''">－交流內容紀錄－</p>
                  <p class="mt-10 ml-10" v-if="scope.row.notes !== null && scope.row.notes !== ''">{{scope.row.notes}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆附件嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                        @confirm="removeHistoryFile(f.id)">
                      <el-button v-if="canEdit" slot="reference" size="mini" type="danger"><i class="el-icon-error"></i> 刪除</el-button>
                    </el-popconfirm>
                  </li>
                </ol>
                </template>
              </el-table-column>


                

                <el-table-column label="操作" width="120" v-if="basicForm.status === 'draft'">
                  <template slot-scope="scope">

                    <el-button type="primary" circle @click="handleEditCust(scope.row)"><i class="el-icon-edit"></i></el-button>

                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆資料嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                       @confirm="handleDelete(scope.row.id)"
                    >
                      <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>


    <el-row v-if="!inEditingMode"> 
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">

        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>新客戶服務紀錄</span>
              <el-button v-if="canEdit" style="float: right; padding: 5px 12px; margin-top: -7px;" 　type="primary"
                         @click.prevent="handleAddNewCust" class="mr-20" id="add_new_cust_btn"><i class="el-icon-circle-plus-outline"></i> 新增</el-button>
            </div>
            <div>
              <el-table :data="newCustTableData" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="客戶名稱" prop="customer.company">
                </el-table-column>
                <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10" v-if="scope.row.customer.name !== null && scope.row.customer.name !== ''">聯絡人: {{scope.row.customer.name}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.customer.address !== null && scope.row.customer.address !== ''">地址: {{scope.row.customer.address}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.customer.phone1 !== null && scope.row.customer.phone1 !== ''">電話: {{scope.row.customer.phone1}}</p>

                  <p class="mt-20 ml-10" v-if="scope.row.promoteCatalog !== '' || scope.row.promoteSample !== '' || scope.row.promoteOther !== ''">－宣傳品－</p>
                  <p class="mt-10 ml-10" v-if="scope.row.promoteCatalog !== null && scope.row.promoteCatalog !== ''">{{scope.row.promoteCatalog}}: {{scope.row.item1Name}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.promoteSample !== null && scope.row.promoteSample !== ''">{{scope.row.promoteSample}}: {{scope.row.item2Name}}</p>
                  <p class="mt-10 ml-10" v-if="scope.row.promoteOther !== null && scope.row.promoteOther !== ''">{{scope.row.promoteOther}}: {{scope.row.item3Name}}</p>

                  <p class="mt-20 ml-10" v-if="scope.row.notes !== null && scope.row.notes !== ''">－交流內容紀錄－</p>
                  <p class="mt-10 ml-10" v-if="scope.row.notes !== null && scope.row.notes !== ''">{{scope.row.notes}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" class="mt-10">
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆附件嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                        @confirm="removeHistoryFile_newCust(f.id)">
                      <el-button v-if="canEdit" slot="reference" size="mini" type="danger"><i class="el-icon-error"></i> 刪除</el-button>
                    </el-popconfirm>
                  </li>
                </ol>
                </template>
              </el-table-column>


                

                <el-table-column label="操作" width="120" v-if="basicForm.status === 'draft'">
                  <template slot-scope="scope">

                    <el-button type="primary" circle @click="handleEditCust_newCust(scope.row)"><i class="el-icon-edit"></i></el-button>

                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆資料嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                       @confirm="handleDelete_newCust(scope.row.id)"
                    >
                      <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-main>
        
      </el-col>
    </el-row>

    <!--    工作項目資料 -->
    <el-row v-if="!inEditingMode"> 
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>其它工作事項</span>
              <!-- <el-button v-if="canEdit" style="float: right; padding: 5px 12px" 　type="primary"
                         @click.prevent="handleAddTask" class="mr-20" id="add_task_btn"><i class="el-icon-circle-plus-outline"></i>  工作紀錄</el-button> -->
            </div>
            <div>
               <el-form class="myform" label-position="top"　:model="basicForm"
                     :rules="visitRules"
                     ref="visitDataForm">
                <el-form-item label="" prop="taskContent" >
                  <el-input ref="taskContent" type="textarea" rows="5" v-model="basicForm.taskContent" autocomplete="off"></el-input>
                </el-form-item>
              </el-form>
             
            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>

    <!--    今日的交通工具與里程數計算 -->
    <el-row v-if="!inEditingMode && basicForm.status !== 'draft'"> 
      <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
        <el-main class="taskMain">
          <el-card class="box-card">
            <div style="padding:20px">
              <div class="mb-20">今日哩程紀錄</div>
              <br/>
              <div v-if="false">
                <el-radio v-model="basicForm.hasMile" label="N" @change="handleMileChange">無</el-radio>
                <el-radio v-model="basicForm.hasMile" label="Y" @change="handleMileChange">有</el-radio>  
              </div>
              <div v-else>
                <el-radio :disabled="true" v-model="basicForm.hasMile" label="N" @change="handleMileChange">無</el-radio>
                <el-radio :disabled="true" v-model="basicForm.hasMile" label="Y" @change="handleMileChange">有</el-radio>  
              </div>
              

            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>
    <el-row v-if="!inEditingMode"> 
      <el-col :xs="24" :sm="24" :lg="24">
        <el-main class="taskMain" v-if="basicForm.hasMile === 'Y'">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>交通工具與里程數</span>
              
              <el-button v-if="false" style="float: right; padding: 5px 12px; margin-top: -7px;" 　type="primary"
                         @click.prevent="handleAddDriving" class="mr-20" id="add_driving_btn"><i class="el-icon-circle-plus-outline"></i> 新增哩程紀錄</el-button>
            </div>
            <div>

              <el-table :data="drivingTableData" empty-text="無資料" stripe  :default-expand-all="true">
                <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
                </el-table-column>
                <el-table-column label="交通工具" prop="carType">
                </el-table-column>
                <el-table-column label="" type="expand" >
                <template slot-scope="scope">
                  <p class="mt-10 ml-10">哩程: {{scope.row.startMile}}~{{scope.row.endMile}}</p>
                  <ol class="ml-10">
                  <li v-for="f in scope.row.fileListDisplay" :key="f.id" >
                    <el-button v-if="isImage(f.fileRepo.name)" type="text" @click="showImage(f.fileRepo.uuid)"> ({{f.fileNote}}) {{f.fileRepo.name}}</el-button>
                    <p style="display:inline-block;" v-else>({{f.fileNote}}) <a :href="displayAvatar(f.fileRepo.uuid)" target=_new>{{f.fileRepo.name}}</a></p>

                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆附件嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                        @confirm="removeHistoryFile_driving(f.id)">
                      <el-button v-if="false" slot="reference" size="mini" type="danger"><i class="el-icon-error"></i> 刪除</el-button>
                    </el-popconfirm>
                  </li>
                </ol>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="120" v-if="false">
                  <template slot-scope="scope1">
                    <el-button type="primary" circle @click="handleEditCust_driving(scope1.row)"><i class="el-icon-edit"></i></el-button>

                    <el-popconfirm
                        class="ml-10 popconfirm-bg"
                        title="確定刪除此筆資料嗎?"
                        confirm-button-text="確定"
                        cancel-button-text="取消刪除"
                        icon="el-iconf-info"
                        icon-color="red"
                       @confirm="handleDelete_driving(scope1.row.id)"
                    >
                      <el-button type="danger" slot="reference" circle> <i class="el-icon-delete"></i></el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>


    <!--    簽核紀錄-->
    <el-row v-if="!inEditingMode"> 
      <el-col :xs="24" :sm="24" :lg="24" v-if="basicForm.status !== 'draft'" class="mt-20">
        <el-main>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>簽核紀錄</span>
            </div>
            <div>

              <el-table :data="historyTableData" empty-text="無資料" stripe :default-expand-all="true">
                <el-table-column label="時間" prop="updatedAt" width="170">
                  <template slot-scope="scope">
                    <p>簽核時間 :</p>
                    <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                    <p class="mt-10">{{ scope.row.signerObj.username }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="結果" prop="signResult">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.signResult === 'N'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                    <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="" type="expand" width="30">
                    <template slot-scope="scope">
                      <p class="mt-10 ml-10">簽核備註 : {{ scope.row.notes }}</p>
                    </template>
                  </el-table-column>

                  <el-table-column>
                  </el-table-column>
              </el-table>

            </div>
          </el-card>
        </el-main>
      </el-col>
    </el-row>


   


    <!-------------------------------------------------------------------------------------------------------->
    <!-------------------------------------------------------------------------------------------------------->
    <!-- editCust -->
    <!-------------------------------------------------------------------------------------------------------->
    <!-------------------------------------------------------------------------------------------------------->

    <!-- 現有客戶 -->
    <el-row v-if="editCust" class="editing-form">
      <el-form class="myform" label-position="top" :model="form" ref="visitForm" label-width="100px" :rules="visitFormRules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="客戶" prop="custId">

               <el-autocomplete
                class="inline-input full-width-input"
                v-model="form.custLabel"
                :fetch-suggestions="querySearch"
                placeholder="輸入客戶名稱進行查詢"
                :trigger-on-focus="false"
                @select="handleSelect"
              ></el-autocomplete>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24">

            <div>宣傳物品</div>
            <el-form-item label="" prop="promoteCatalog" >
              <el-checkbox v-model="form.catalogCheckFlag"  label="型錄" @change="handleCatalogChange">型錄</el-checkbox>
            </el-form-item>
            <el-form-item v-if="form.catalogCheckFlag" label="" prop="item1Name" style="margin-top: -10px;">
              <el-autocomplete style="width: 100%;"
                class="inline-input full-width-input"
                v-model="form.item1Name"
                :fetch-suggestions="queryModelItem"
                placeholder="輸入用品名稱"
                :trigger-on-focus="false"
                @select="handleSelectItem1"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item label="" prop="promoteSample" >
              <el-checkbox v-model="form.sampleCheckFlag" label="型錄" @change="handleSampleChange">樣品</el-checkbox>
            </el-form-item>
            <el-form-item v-if="form.sampleCheckFlag" label="" prop="item2Name" style="margin-top: -10px;">
              <el-autocomplete style="width: 100%;"
                class="inline-input full-width-input"
                v-model="form.item2Name"
                :fetch-suggestions="querySampleItem"
                placeholder="輸入用品名稱"
                :trigger-on-focus="false"
                @select="handleSelectItem2"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item label="" prop="promoteOther" >
              <el-checkbox v-model="form.otherCheckFlag" label="型錄" @change="handleOtherChange">其它</el-checkbox>
            </el-form-item>
            <el-form-item v-if="form.otherCheckFlag" label="" prop="item3Name" style="margin-top: -10px;">
              <el-autocomplete style="width: 100%;"
                class="inline-input full-width-input"
                v-model="form.item3Name"
                :fetch-suggestions="queryOtherItem"
                placeholder="輸入用品名稱"
                :trigger-on-focus="false"
                @select="handleSelectItem3"
              ></el-autocomplete>
            </el-form-item>
            
            
          </el-col>
        </el-row>

        
        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="交流內容紀錄" prop="notes">
              <el-input type="textarea" v-model="form.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-for="(btn, i) in btnCount" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
          <el-col :xs="12" :sm="12" :md="12" class="pr-10">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" >
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20 mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField()">新增上傳</el-button>
          </el-col>
        </el-row>

      </el-form>

      <div  style="float: right;" class="mt-20 mb-20">
        <el-button @click="cancelAddCust">取 消</el-button>
        <el-button type="primary" @click="saveCustomerVisit('visitForm')">確 定</el-button>
      </div>
    </el-row>



    <!-- 新客戶 -->
    <el-row v-if="editNewCust" class="editing-form">
      <el-form class="myform" label-position="top" :model="new_cust_form" ref="new_cust_visitForm" label-width="100px" :rules="new_cust_visitForm_rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="客戶" prop="custId">

               <el-autocomplete
                class="inline-input full-width-input"
                v-model="new_cust_form.custLabel"
                :fetch-suggestions="querySearch"
                placeholder="輸入客戶名稱進行查詢"
                :trigger-on-focus="false"
                @select="handleSelect_newCust"
              ></el-autocomplete>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24">

            <div>宣傳物品</div>
            <el-form-item label="" prop="promoteCatalog" >
              <el-checkbox v-model="catalogCheckFlag_newCust"  label="型錄" @change="handleCatalogChange_newCust">型錄</el-checkbox>
            </el-form-item>
            <el-form-item v-if="catalogCheckFlag_newCust" label="" prop="item1Name" style="margin-top: -10px;">
              <el-autocomplete style="width: 100%;"
                class="inline-input full-width-input"
                v-model="new_cust_form.item1Name"
                :fetch-suggestions="queryModelItem"
                placeholder="輸入用品名稱"
                :trigger-on-focus="false"
                @select="handleSelectItem1_newCust"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item label="" prop="promoteSample" >
              <el-checkbox v-model="sampleCheckFlag_newCust" label="型錄" @change="handleSampleChange_newCust">樣品</el-checkbox>
            </el-form-item>
            <el-form-item v-if="sampleCheckFlag_newCust" label="" prop="item2Name" style="margin-top: -10px;">
              <el-autocomplete style="width: 100%;"
                class="inline-input full-width-input"
                v-model="new_cust_form.item2Name"
                :fetch-suggestions="querySampleItem"
                placeholder="輸入用品名稱"
                :trigger-on-focus="false"
                @select="handleSelectItem2_newCust"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item label="" prop="promoteOther" >
              <el-checkbox v-model="otherCheckFlag_newCust" label="型錄" @change="handleOtherChange_newCust">其它</el-checkbox>
            </el-form-item>
            <el-form-item v-if="otherCheckFlag_newCust" label="" prop="item3Name" style="margin-top: -10px;">
              <el-autocomplete style="width: 100%;"
                class="inline-input full-width-input"
                v-model="new_cust_form.item3Name"
                :fetch-suggestions="queryOtherItem"
                placeholder="輸入用品名稱"
                :trigger-on-focus="false"
                @select="handleSelectItem3_newCust"
              ></el-autocomplete>
            </el-form-item>
            
            
          </el-col>
        </el-row>

        
        <el-row class="mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="交流內容紀錄" prop="notes">
              <el-input type="textarea" v-model="new_cust_form.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-for="(btn, i) in btnCount" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
          <el-col :xs="12" :sm="12" :md="12" class="pr-10">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="new_cust_form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" >
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess_newCust"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove_newCust">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20 mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField_newCust()">新增上傳</el-button>
          </el-col>
        </el-row>

      </el-form>

      <div  style="float: right;" class="mt-20 mb-20">
        <el-button @click="cancelAddCust_newCust">取 消</el-button>
        <el-button type="primary" @click="saveCustomerVisit_newCust('new_cust_visitForm')">確 定</el-button>
      </div>
    </el-row>


    <!-- 哩程 -->
    <el-row v-if="editDriving" class="editing-form">
      <el-form class="myform" label-position="top" 
              :model="driving_form" 
              ref="driving_form" 
             :rules="driving_form_rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="汽車/機車" prop="carType">
              <el-select v-model="driving_form.carType" placeholder="請選擇" @change="handleDrivingChange()">
                <el-option label="汽車" value="汽車"></el-option>
                <el-option label="機車" value="機車"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="哩程數"></el-form-item>
          </el-col>
        </el-row>

        <el-row >
          <el-col :xs="24" :sm="24" :md="12" style="margin-top: -20px;">
            <el-form-item label="起" prop="startMile">
              <el-input-number v-model="driving_form.startMile" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <el-form-item label="迄" prop="endMile">
              <el-input-number v-model="driving_form.endMile" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-for="(btn, i) in btnCount" :key="i" style="background-color: #f4f4f5; padding: 8px; margin-top: 8px;">
          <el-col :xs="12" :sm="12" :md="12" class="pr-10">
            <el-form-item label="檔案備註">
              <el-input placeholder="檔案備註" v-model="driving_form.fileNotes[i]" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" >
            <el-form-item label="附件">
              <el-upload
                  :multiple="false"
                  class="upload-demo"
                  action="/api/file/upload"
                  :on-success="handleUploadSuccess_driving"
                  :before-upload="beforeUpload"
                  :on-remove="handleFileRemove_driving">
                <el-button size="small" type="primary">上傳文件</el-button>
                <div slot="tip" class="el-upload__tip">限上傳 5M 以下的文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb-20 mt-20">
          <el-col :xs="24" :sm="24" :md="24">
            <el-button size="small" type="primary" @click="newUploadField_driving()">新增上傳</el-button>
          </el-col>
        </el-row>


      </el-form>
      
      <div  style="float: right;" class="mt-20 mb-20">
        <el-button @click="cancelAddDriving">取 消</el-button>
        <el-button type="primary" @click="saveDriving('driving_form')">確 定</el-button>
      </div>

    </el-row>

  <!-- 附件圖-->
  <el-row>
    <el-dialog title="附件圖"
               :visible.sync="img.dialog"
               :width="dw">
        <div class="demo-image">
          <el-image
            style="width: 100%; max-width: 100%; height: 100%;"
            :src="img.url"
            fit="cover" lazy>
              <div slot="placeholder" class="image-slot">
              <i class="el-icon-loading"></i> 開啟中...
            </div>
            </el-image>
        </div>
     </el-dialog>
  </el-row>

  </div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";

export default {
  name: "TodoDetailBrandSales",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }
    

    return {
      from:'',
      editTask: false,
      editCust: false,
      editNewCust: false,
      editDriving: false,

      img:{
        dialog: false,
        url:''
      },

      props: {
        label: 'name'
      },
      historyTableData: [],
      precheckListOption: [],

      basicForm: {
        id: '',
        title: '',
        startDate: '',
        userObj: {
          username:''
        },
        status:'',
        endDate: '',
        preCheckItem: '',
        preCheckTree:[],
        visitRoute: '',
        hasMile:'N'
      },

      visitForm: {
        customerId: '',
        arrivalTime: '',
        deliveryContent: [],
        serviceContent: [],
        paymentReceive: [],
        notes: '',
        fileList: []
      },

      task: {
        tableData:[],
        dialog: false,
        form: {
          mytodoId: '',
          id:'',
          fileList:[],
          fileNotes:[],
          fileListDisplay:[]
        },
        btnCount:0,
        taskTypeOptions:[]
      },

      drivingTableData:[],

      
      
      catalogCheckFlag_newCust: false,
      sampleCheckFlag_newCust: false,
      otherCheckFlag_newCust: false,


      loading: false,
      dw: '50%',
      fileList: [],
      preCheckOption: [],
      precheckList: [],
      tableData: [],
      newCustTableData: [],
      options: [],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      deliveryContentOptions: ['送店', '指送'],
      shippingToDifferentAddress: false,
      serviceContentOptions: ['補目錄', '做宣傳', '交流','收退料', '放帳單'],
      paymentReceiveOptions: ['現金', '期票'],
      btnCount: 0,

      form: {
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        notes: '',
        fileList: [],
        fileNotes: [],
        custLabel:'',
        
        promoteCatalog:'',
        promoteSample:'',
        promoteOther:'',
        item1Id:'',
        item2Id:'',
        item3Id:'',
        item1Name:'',
        item2Name:'',
        item3Name:'',

        catalogCheckFlag: false,
        sampleCheckFlag: false,
        otherCheckFlag: false
      },

      new_cust_form: {
        mytodoId: '',
        custId: '',
        arrivalTime: '',
        notes: '',
        fileList: [],
        fileNotes: [],
        custLabel:'',
        newCust:'Y',

        promoteCatalog:'',
        promoteSample:'',
        promoteOther:'',
        item1Id:'',
        item2Id:'',
        item3Id:'',
        item1Name:'',
        item2Name:'',
        item3Name:'',

        phone1:'',
        address:'',
        name:'',
        company:''
      },

      driving_form: {
        mytodoId: '',
        carType:'',
        startMile:0,
        endMile:0,
        fileList: [],
        fileNotes: []
      },

      rules: {
        title: [{validator: checkName, trigger: 'change'}],
        startDate: [{validator: checkName, trigger: 'change'}]
      },
      visitRules: {
        notes: [{required:true, validator: checkName, trigger: 'change'}]
      },
      visitFormRules: {
        custId: [{required: true, validator: checkName, trigger: 'change'}]
      },
      taskFormRule:{
        notes: [{required:true, validator: checkName, trigger: 'change'}],
        taskType: [{required:true, validator: checkName, trigger: 'change'}],
      },
      new_cust_visitForm_rules: {
        company: [{required: true, validator: checkName, trigger: 'change'}],
        name: [{required: true, validator: checkName, trigger: 'change'}],
        phone1: [{required: true, validator: checkName, trigger: 'change'}]
      },
      driving_form_rules: {

      }
      

    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    canEdit() {
      return this.basicForm.status === 'draft' || this.basicForm.status === 'reject'
    },
    inEditingMode(){
      return this.editCust || this.editNewCust || this.editDriving
    }
  },
  methods: {
    handleMileChange(){
      console.log(this.basicForm.hasMile)
    },
    //型錄勾選
    handleCatalogChange() {
      console.log('this.form.catalogCheckFlag:', this.form.catalogCheckFlag);
      if (this.form.catalogCheckFlag) {
         this.form.promoteCatalog = '型錄'

      } else {
        this.form.item1Name = ''
        this.form.item1Id = ''
        this.form.promoteCatalog = ''
      }
    },
    //樣品勾選
    handleSampleChange(){
      
      if (this.form.sampleCheckFlag) {
         this.form.promoteSample = '樣品'

      } else {
        this.form.item2Name = ''
        this.form.item2Id = ''
        this.form.promoteSample = ''
      }
    },
    //其它勾選
    handleOtherChange(){
      if (this.form.otherCheckFlag) {
         this.form.promoteOther = '其它'

      } else {
        this.form.item3Name = ''
        this.form.item3Id = ''
        this.form.promoteOther = ''
      }
    },
    

    handleCatalogChange_newCust(){
      if (this.catalogCheckFlag_newCust) {
         this.new_cust_form.promoteCatalog = '型錄'

      } else {
        this.new_cust_form.item1Name = ''
        this.new_cust_form.item1Id = ''
        this.new_cust_form.promoteCatalog = ''
      }
    },
    //樣品勾選
    handleSampleChange_newCust(){
      if (this.sampleCheckFlag_newCust) {
         this.new_cust_form.promoteSample = '樣品'

      } else {
        this.new_cust_form.item2Name = ''
        this.new_cust_form.item2Id = ''
        this.new_cust_form.promoteSample = ''
      }
    },
    //其它勾選
    handleOtherChange_newCust(){
      
      if (this.otherCheckFlag_newCust) {
         this.new_cust_form.promoteOther = '其它'

      } else {
        this.new_cust_form.item3Name = ''
        this.new_cust_form.item3Id = ''
        this.new_cust_form.promoteOther = ''
      }
    },


    queryItem(str, cb){
      this.request.get("/item/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.itemName,
              id: item.id
            }
          })
          cb(list)
        }
      })
    },

    queryModelItem(str, cb){
      let url = '/item/model/q/my?keyword='+str+"&area="+this.userInfo.area
      this.request.get(url).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.itemName,
              id: item.itemId
            }
          })
          cb(list)
        }
      })
    },

    querySampleItem(str, cb){
      let url = '/item/sample/q/my?keyword='+str+"&area="+this.userInfo.area
      this.request.get(url).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.itemName,
              id: item.itemId
            }
          })
          cb(list)
        }
      })
    },

    queryOtherItem(str, cb){
      let url = '/item/other/q/my?keyword='+str+"&area="+this.userInfo.area
      this.request.get(url).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.itemName,
              id: item.itemId
            }
          })
          cb(list)
        }
      })
    },

    

    handleSelectItem1(item) {
      this.form.item1Id = item.id
    },
    handleSelectItem2(item) {
      this.form.item2Id = item.id
    },
    handleSelectItem3(item) {
      this.form.item3Id = item.id
    },
    
    handleSelectItem1_newCust(item) {
      this.new_cust_form.item1Id = item.id
    },
    handleSelectItem2_newCust(item) {
      this.new_cust_form.item2Id = item.id
    },
    handleSelectItem3_newCust(item) {
      this.new_cust_form.item3Id = item.id
    },


    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    // removeTaskHistoryFile(id) {
    //   this.request.delete("/todo/div-mgr/history/file/" + id).then(res => {
    //     if (res.code === '200') {
    //       this.taskLoadHistory()
    //       this.showResult('success', '附件刪除成功.')
    //     } else {
    //       this.showResult('error', '附件刪除失敗.')
    //     }
    //   })
    // },

    //參數為勾選的值，array
    handleDeliveryChange(selectedItem){
      console.log(selectedItem)
      console.log(selectedItem.includes('指送'))
      if (selectedItem.includes('指送')) {
        this.shippingToDifferentAddress = true
      } else {
        this.shippingToDifferentAddress = false
      }
    },
    querySearch(str, cb){
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleSelect(item) {
      this.form.custId = item.id
    },
    handleSelect_newCust(item) {
      this.new_cust_form.custId = item.id
    },
    loadCustomerHistoryData() {
      this.request.get("/todo/customer/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },
    loadCustomerHistoryData_newCust() {
      this.request.get("/todo/customer/history/new_cust/" + this.new_cust_form.mytodoId).then(res => {
        if (res.code === '200') {
          this.newCustTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },

    loadCustomerHistoryData_driving() {
      this.request.get("/todo/driving/history/" + this.driving_form.mytodoId).then(res => {
        if (res.code === '200') {
          this.drivingTableData = res.data
        } else {
          this.showResult('error', '哩程紀錄撈取失敗')
        }
      })
    },
    
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadCustomerHistoryData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleDraft() {
      // let selectedIds = this.$refs.tree.getCheckedKeys();
      // this.basicForm.preCheckItem = selectedIds.join(",")
      this.handleSubmitForm()
    },
    handleSign() {
      this.$refs['visitDataForm'].validate(async valid => {
        if (valid) {
          this.$confirm('資料填寫已完成，按下「確定」後將呈主管簽核?', '提醒', {
            confirmButtonText: '確定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.basicForm.status = "review"
            this.request.post("/todo/signoff", this.basicForm).then(res => {
              if (res.code === '200') {
                this.showResult('success', '表單送簽核成功')
                this.$nextTick(()=>{
                    this.goBack()
                 })
              } else {
                this.showResult('error', '表單送簽核失敗')
              }
            })
          }).catch(() => {

          });
        }
      })
    },
    handleAddCust() {
      this.editTask = false
      this.editNewCust = false
      this.editCust = true
      
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },

    handleAddNewCust() {
      
      this.editTask = false
      this.editNewCust = true
      this.editCust = false
      
      this.new_cust_form.id = null
      this.new_cust_form.fileList = []
      this.new_cust_form.fileNotes = []
      this.btnCount = 0
    },
    

    handleAddTask() {
      this.editTask = true
        this.editCust = false
      
        this.task.form.id = null
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.btnCount = 0


      
    },  
    handleTaskEdit(rowData) {
      
      this.task.form = rowData
        this.task.form.fileList = []
        this.task.form.fileNotes = []
        this.task.form.fileListDisplay = []
        this.task.btnCount = 0
        this.task.form.taskType = rowData.taskType

      this.$nextTick(()=>{
        this.editCust = false
        this.editTask = true
      
      })
      
    },
    handleEditCust(rowData) {
      console.log("edit cust:", rowData)
      this.editTask = false
      this.editCust = true
      this.editNewCust = false

      this.form = rowData
      this.form.fileList = []
      this.form.fileNotes = []
      this.form.fileListDisplay = []
      this.btnCount = 0

      this.form.custLabel = rowData.customer.company + "(" + rowData.customer.name + ")"

      if (rowData.item1Name !== null && rowData.item1Name !== '') {
        this.form.catalogCheckFlag = true
      }
      if (rowData.item2Name !== null && rowData.item2Name !== '') {
        this.form.sampleCheckFlag = true
      }
      if (rowData.item3Name !== null && rowData.item3Name !== '') {
        this.form.otherCheckFlag = true
      }
      
    },
    handleEditCust_newCust(rowData) {
      console.log("handleEditCust_newCust:", rowData)
      this.editTask = false
      this.editCust = false
      this.editNewCust = true

      this.new_cust_form = rowData
      this.new_cust_form.fileList = []
      this.new_cust_form.fileNotes = []
      this.new_cust_form.fileListDisplay = []
      this.btnCount = 0


      if (rowData.item1Name !== '' || rowData.item1Name !== null) {
        this.catalogCheckFlag_newCust = true
      }
      if (rowData.item2Name !== '' || rowData.item2Name !== null) {
        this.sampleCheckFlag_newCust = true
      }
      if (rowData.item3Name !== '' || rowData.item3Name !== null) {
        this.otherCheckFlag_newCust = true
      }
      
      this.new_cust_form.custLabel = rowData.customer.company + "(" + rowData.customer.name + ")"
    },
    handleEditCust_driving(rowData) {
      this.editDriving = true

      this.driving_form = rowData
      this.driving_form.fileList = []
      this.driving_form.fileNotes = []
      this.driving_form.fileListDisplay = []
      this.btnCount = 0
    },



    handleDelete(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    handleDelete_newCust(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData_newCust()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    handleDelete_driving(id) {
      this.request.delete("/todo/driving/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData_driving()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    removeHistoryFile(id) {
      this.request.delete("/todo/customer/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.loadCustomerHistoryData()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
    removeHistoryFile_newCust(id) {
      this.request.delete("/todo/customer/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.loadCustomerHistoryData_newCust()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
    removeHistoryFile_driving(id) {
      console.log('removeHistoryFile_driving')
      this.request.delete("/todo/driving/history/file/" + id).then(res => {
        if (res.code === '200') {
          this.loadCustomerHistoryData_driving()
          this.showResult('success', '附件刪除成功.')
        } else {
          this.showResult('error', '附件刪除失敗.')
        }
      })
    },
    

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    closeTaskDialog() {
      //this.task.form.notes = ''
      this.$refs['taskForm'].resetFields()
      this.task.btnCount = 0
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "50%";
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data

          if (res.data.preCheckItem !== '') {
            this.precheckListOption = res.data.preCheckItem.split(",")
          }
         
          if (res.data.hasMile === null) {
            this.basicForm.hasMile = 'N'
          }


        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      this.form.todoType = this.getTodoType()
    },
    getTodoType() {
      this.userInfo.id;
    },
    // loadPreCheckItem() {
    //   let req = '/dic/type?queryField=pre_check'
    //   this.request.get(req).then(res => {
    //     if (res.code === '200') {
    //       this.preCheckOption = res.data
    //     }
    //   })
    // },
    goBack() {
      this.$router.push('/daily/todo')
    },
    goBackReport() {
      this.$router.push('/report/miles-statistic')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    

    handleUploadSuccess_newCust(res, file) {
      this.new_cust_form.fileList.push(res.uuid)
    },
    handleFileRemove_newCust(file, fileList) {
      this.new_cust_form.fileList = this.new_cust_form.fileList.filter(e => e !== file.response.uuid)
    },
    
    handleUploadSuccess_driving(res, file) {
      this.driving_form.fileList.push(res.uuid)
    },
    handleFileRemove_driving(file, fileList) {
      this.driving_form.fileList = this.driving_form.fileList.filter(e => e !== file.response.uuid)
    },

    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },

    saveCustomerVisit(formName) {
      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {

           this.request.post("/todo/customer/history", this.form).then(res => {
              if (res.code === '200') {
                this.reset_add_form();

                this.editCust = false
                this.loadCustomerHistoryData()
                this.showResult('success', '新增成功')

                this.$nextTick(()=>{
                  document.getElementById("add_cust_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })

    },

    saveCustomerVisit_newCust(formName) {
      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {

            console.log(this.new_cust_form)

           this.request.post("/todo/customer/history", this.new_cust_form).then(res => {
              if (res.code === '200') {
                this.editNewCust = false
                this.loadCustomerHistoryData_newCust()

                this.showResult('success', '新增成功')
                this.$nextTick(()=>{
                  document.getElementById("add_new_cust_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })

    },

    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    newUploadField() {
      this.btnCount++
    },
    newUploadField_newCust() {
      this.btnCount++
    },
    newUploadField_driving() {
      this.btnCount++
    },
    
    loadTaskType() {
      let req = '/dic/type?queryField=sales_manager_task'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.task.taskTypeOptions = res.data
        }
      })
    },
    reset_add_form(){
      let _todoId = this.form.mytodoId
      console.log('_todoId:', _todoId)
      this.form = {
        mytodoId: _todoId,
        custId: '',
        arrivalTime: '',
        notes: '',
        fileList: [],
        fileNotes: [],
        custLabel:'',
        
        catalogCheckFlag: false,
        sampleCheckFlag: false,
        otherCheckFlag: false,

        promoteCatalog:'',
        promoteSample:'',
        promoteOther:'',
        item1Id:'',
        item2Id:'',
        item3Id:'',
        item1Name:'',
        item2Name:'',
        item3Name:''
      }
      this.btnCount = 0
      console.log('reset_add_form:', this.form)


    },
    cancelAddCust() {
      this.reset_add_form()

      this.editCust = false
      this.$nextTick(()=>{
        document.getElementById("add_cust_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    cancelAddCust_newCust() {
      this.editNewCust = false
      this.$refs['new_cust_visitForm'].resetFields()
      this.$nextTick(()=>{
        document.getElementById("add_new_cust_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    
    cancelAddTask() {
      this.$refs['taskForm'].resetFields()

      this.editTask = false
      
      this.$nextTick(()=>{
        document.getElementById("add_cust_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      })
    },
    taskLoadHistory() {
      this.request.get("/todo/div-mgr/history/" + this.task.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.task.tableData = res.data
        } else {
          this.showResult('error', '工作項目紀錄撈取失敗')
        }
      })
    },
    taskHandleUploadSuccess(res, file) {
      this.task.form.fileList.push(res.uuid)
    },
    taskNewUploadField() {
      this.task.btnCount++
    },
    taskHandleFileRemove(file, fileList) {
      this.task.form.fileList = this.task.form.fileList.filter(e => e !== file.response.uuid)
    },
    taskFormSave(formName){
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.request.post("/todo/div-mgr/history", this.task.form).then(res => {
              if (res.code === '200') {
                this.$refs['taskForm'].resetFields()

                this.editTask = false
                this.taskLoadHistory()
                this.showResult('success', '新增成功')
                this.$nextTick(()=>{
                  document.getElementById("add_task_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    taskHandleDeleteHistory(id) {
      this.request.delete("/todo/div-mgr/history/" + id).then(res => {
        if (res.code === '200') {
          this.taskLoadHistory()
          this.showResult('success', '資料刪除成功.')
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },


    handleAddDriving(){
      this.editDriving = true
      this.driving_form.id = null
      this.driving_form.fileList = []
      this.driving_form.fileNotes = []
      this.btnCount = 0
    },

    cancelAddDriving(){
      this.editDriving = false
    },
    handleDrivingChange(){
      console.log(this.driving_form.carType)
    },
    saveDriving(formName){
      console.log(this.driving_form)

      this.$refs[formName].validate(async valid => {
        
        if (valid) {
          try {
            this.request.post("/todo/driving/history", this.driving_form).then(res => {
              if (res.code === '200') {
                this.editDriving = false
                this.loadCustomerHistoryData_driving()

                this.$nextTick(()=>{
                  this.showResult('success', '新增成功')
                  document.getElementById("add_driving_btn").scrollIntoView({behavior: 'smooth', inline:'nearest'})
                })
              } else {
                this.showResult('error', res.message)
              }
            })
          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })

    }


  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
    }
  },
  mounted() {
    this.form.mytodoId = this.$route.params.mytodoId
    this.task.form.mytodoId = this.$route.params.mytodoId
    this.new_cust_form.mytodoId = this.$route.params.mytodoId
    this.driving_form.mytodoId = this.$route.params.mytodoId

    let from = this.$route.query.from
    if (typeof from === 'undefined') {
      this.from = ''
    } else {
      this.from = from
    }

    //
    this.loadCustomerHistoryData()

    this.loadCustomerHistoryData_newCust()

    this.loadCustomerHistoryData_driving()

    this.loadJobSignHistory()

    //設定一些欄位預設值
    this.formDefault()

    //出勤前檢查工作選項
    //this.loadPreCheckItem()

    //撈我負責的客戶
    //this.loadMyCustomer()

    this.taskLoadHistory()
    //this.loadTaskType()

    this.setDialogWidth();
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.myform >>> .el-form-item__label {
  padding: 0;
}


.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0 4px;
}
.el-table {
  padding: 0;
}

.el-form--label-top .el-form-item__label {
  padding: 0;
}
.el-autocomplete {
  width: 100%;
}
.el-card__body {
  padding: 20px 0 !important;
}


</style>
